import { t } from 'i18next';

export const renderNumber = (value: number | undefined, precision: number) =>
  value?.toFixed(precision) ?? t('common.na');

export interface ITargetProps {
  target: number;
  value: number | undefined;
  precision: number;
}
